/**
 * Язык подписей внутри компонентов дизайн-системы (те немногие тексты, что
 * зашиты в сами компоненты). Приложение вызывает `setUiLanguage` из своего
 * `LanguageProvider`; при смене языка оно же пересобирает дерево, поэтому
 * компонентам хватает модульного значения без контекста.
 *
 *   const MESSAGES = { ru: { loading: 'Загрузка…' }, en: { loading: 'Loading…' } }
 *   uiText(MESSAGES).loading
 */
export type UiLanguage = 'ru' | 'en'

let current: UiLanguage = 'ru'

export const setUiLanguage = (lang: UiLanguage): void => {
  current = lang
}

export const getUiLanguage = (): UiLanguage => current

type Mirror<T> = { [K in keyof T]: T[K] extends string ? string : T[K] }

export const uiText = <T extends Record<string, unknown>>(m: { ru: T; en: Mirror<T> }): T =>
  (current === 'en' ? m.en : m.ru) as T
